import { useId, type ReactNode } from 'react';
import { IconeSeta } from '../Icones.js';

/**
 * Cartao que abre e fecha pelo cabecalho (grupos de medidas da Ficha). O
 * cabecalho inteiro e o botao: titulo e resumo a esquerda, seta a direita.
 * Fechado, o conteudo fica no DOM mas escondido, para a impressao sair com
 * tudo aberto.
 */
export function Recolhivel({
  titulo,
  resumo,
  aberto,
  onAlternar,
  children,
}: {
  titulo: string;
  /** Linha de apoio, para ler o principal sem abrir. */
  resumo?: ReactNode;
  aberto: boolean;
  onAlternar: () => void;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <section className="overflow-hidden rounded-(--radius-painel) border border-borda bg-superficie shadow-cartao">
      <h3>
        <button
          type="button"
          aria-expanded={aberto}
          aria-controls={id}
          onClick={onAlternar}
          className="flex min-h-14 w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-superficie-2/70 sm:px-5"
        >
          <span className="min-w-0 flex-1">
            <span className="block text-[15px] font-semibold text-texto">{titulo}</span>
            {resumo && <span className="numero mt-0.5 block truncate text-xs text-apagado">{resumo}</span>}
          </span>
          <span
            aria-hidden
            className="grid size-8 shrink-0 place-items-center rounded-[9px] border border-borda bg-superficie text-apagado pointer-coarse:size-11 print:hidden"
          >
            <IconeSeta
              width={16}
              height={16}
              className={`transition-transform duration-200 ${aberto ? 'rotate-180' : ''}`}
            />
          </span>
        </button>
      </h3>
      <div
        id={id}
        role="region"
        aria-label={titulo}
        className={`border-t border-borda ${aberto ? '' : 'hidden print:block'}`}
      >
        {children}
      </div>
    </section>
  );
}
